<h2>
  Remittance Inventory
</h2>
<hr />
<div class="remitContainer">
  <div id="remit-grid" class="row">
    <div class="col-md-12">
      <app-grid-wrapper
        #grid
        [gridSize]="GridSize.small"
        [selectRowOnCellClick]="true"
        persistenceKey="remitList"
        [autoHeight]="false"
        [pageSizeOptions]="[10, 20, 50]"
      >
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-default" (click)="refresh()">Refresh</button>
          </div>
        </div>
      </app-grid-wrapper>
    </div>
  </div>

  <div class="panel panel-default stick" *ngIf="model">
    <div class="panel-body">
      <div class="row">
        <ng-container *ngFor="let def of detailViewColumns">
          <ng-container *ngIf="def.headerName">
            <div class="col-xs-6 col-sm-4 col-md-3">
              <span class="itemLabel">{{ def.headerName }}:</span>
              <span class="itemValue" *ngIf="!def.cellRenderer">{{ model[def.field] }}</span>
              <span
                class="itemValue"
                *ngIf="def.cellRenderer"
                [innerHTML]="def.cellRenderer(model)"
              ></span>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <hr class="thin" />

      <div class="row button-row col-md-12 text-center">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Update
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li (click)="showDeleteRemittanceModal()">
              <a href="javascript:void(0)">Delete</a>
            </li>
          </ul>
        </div>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isProgressViewShown }"
          (click)="toggleProcessingProgress()"
        >
          Processing Progress
        </button>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isExportViewShown }"
          (click)="toggleEncounterConfigComparison()"
        >
          Encounter Config Comparison
        </button>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isX12ViewShown }"
          (click)="toggleSummaryConfigComparison()"
        >
          EDI Comparison
        </button>
        <button
          type="button"
          class="btn btn-default"
          *ngIf="canUnmatchClaim()"
          (click)="unmatchSelectedClaim()"
        >
          Unmatch Claim
        </button>
        <button
          type="button"
          class="btn btn-default"
          *ngIf="!model.ClaimId"
          (click)="showMatchClaimModal()"
        >
          Match Claim
        </button>

        <div class="btn-group" *ngIf="model">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="!model.AvailableActions || model.AvailableActions.length === 0"
          >
            Actions
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li *ngFor="let action of model.AvailableActions" (click)="performAction(action)">
              <a href="javascript:void(0)">{{ action.ActionName }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div id="remit-progress-grid" class="row" [ngClass]="{ hidden: !model || !isProgressViewShown }">
    <div class="col-md-12">
      <app-grid-wrapper #gridProgress [gridSize]="GridSize.small" [autoHeight]="false">
        <button class="btn btn-default" (click)="closePanels()">
          Close Processing Progress
          <span
            aria-hidden="true"
            style="
              font-size: 24px;
              line-height: 16px;
              vertical-align: text-bottom;
              font-weight: bold;
            "
            >&times;</span
          >
        </button>
      </app-grid-wrapper>
    </div>
  </div>

  <div id="remit-export-grid" class="row" [hidden]="!model || !isExportViewShown">
    <div class="col-md-12">
      <app-grid-wrapper #gridExport (cellValueChanged)="configFieldChanged($event)" [autoHeight]="false">
        <button class="btn btn-default" (click)="closePanels()">
          Close Encounter Config Comparison
          <span
            aria-hidden="true"
            style="
              font-size: 24px;
              line-height: 16px;
              vertical-align: text-bottom;
              font-weight: bold;
            "
            >&times;</span
          >
        </button>
      </app-grid-wrapper>
    </div>
  </div>

  <div id="remit-x12-comparison" class="row" [hidden]="!model || !isX12ViewShown">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row">
            <div class="col-md-8">
              <button class="btn btn-default" (click)="closeX12View()">
                Close EDI Comparison
                <span
                  aria-hidden="true"
                  style="
                    font-size: 24px;
                    line-height: 16px;
                    vertical-align: text-bottom;
                    font-weight: bold;
                  "
                  >&times;</span
                >
              </button>
            </div>
            <div class="col-md-2">
              <button class="btn btn-default" (click)="gotoDiff(-1)" [disabled]="currentDiff <= 1">
                Previous
              </button>
              <button
                class="btn btn-default"
                (click)="gotoDiff(1)"
                [disabled]="currentDiff >= differences"
              >
                Next
              </button>
            </div>
            <div class="col-md-2" style="padding: 7px">
              {{ differences }} differences were found
            </div>
          </div>
        </div>
        <div class="panel-body" style="padding: 0">
          <div class="row">
            <div class="col-md-12">
              <app-diff
                #diff
                [resultid]="'remit-x12-comparison-result'"
                [hasHeader]="true"
                [leftHeader]="'835 In'"
                [rightHeader]="'835 Out'"
                [compareHeader]="'EDI Comparison'"
              ></app-diff>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-audit-detail
    id="remit-auditDetail-grid"
    #auditDetail
    [hidden]="!model || !isAuditView"
    (closeClicked)="closeAuditView()"
  ></app-audit-detail>
</div>
